import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './pages/App.jsx'
import { DataProvider } from './contexts/DataContext'
import './styles.css'

createRoot(document.getElementById('root')).render(
  <DataProvider>
    <App />
  </DataProvider>
)